/* eslint-disable @typescript-eslint/no-unsafe-member-access */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import icomoon from './icomoon.ttf';
import RobotoRegular from './Roboto-Regular.ttf';
import RobotoMedium from './Roboto-Medium.ttf';
import RobotoBold from './Roboto-Bold.ttf';

const iconFontStyles = `
@font-face {
  src: url(${RobotoRegular});
  font-family: Roboto-Regular;
}
@font-face {
  src: url(${RobotoMedium});
  font-family: Roboto-Medium;
}
@font-face {
  src: url(${RobotoBold});
  font-family: Roboto-Bold;
}
@font-face {
  src: url('${icomoon as string}') format('truetype') ;
  font-family: icomoon;
}`;

// Create stylesheet
const style = document.createElement('style');
style.type = 'text/css';
if (style.styleSheet) {
  style.styleSheet.cssText = iconFontStyles;
} else {
  style.appendChild(document.createTextNode(iconFontStyles));
}
// Inject stylesheet
document.head.appendChild(style);